<div class="modal">
  <div class="modal-overlay" (click)="cancel($event)"></div>
  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between">
        <h4 class="modal-title">{{ modalTitle }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel($event)"></button>
      </div>
      <div class="modal-body">
        @for (addressItem of addressList; track addressItem) {
          <div class="my-3">
            <app-address-detail class="w-100" [address]="addressItem" [isHeaderVisible]="false" [showDeleteButton]="true" (click)="select(addressItem)" (deleteAddressEvent)="adressDeleteItem($event)"> </app-address-detail>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary ms-auto" data-bs-dismiss="modal" (click)="submit($event)">{{ submitButtonLabel }}</button>
      </div>
    </div>
  </div>
</div>
